import React from 'react';
import { useQuery } from 'react-query';
import { SingleValue } from 'react-select';
import api from '../../../components/api';
import getAllRoutes from './dummyDataRes/getAllRoutes.json';

function useAnalytics() {
  /*
 *
 *
 *
 *
 *
 *
 *
 */

  /*
  * Handle current weekly sales
  * 0. All
  * 1. Routes
  * 2. Clients
  */
  const [step, setStep] = React.useState<number>(0);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Data for React Select options
  * 1. Routes
  * 2. Clients
  * 3. Vending Machine
  */

  // 1. Routes
  const { data: routeRes, isLoading: routeLoad } = useQuery(
    ['getAll', 'routes'],
    () => api.routes.getAll(),
  );
  const routeList: {value: number, label: string}[] = React.useMemo(() => {
    const resData: typeof getAllRoutes | undefined = routeRes?.data?.data;
    if (resData) {
      return resData.map((data) => ({
        value: data.id,
        label: data.name,
        // label: data.user.firstname + data.user.lastname,
      }));
    }
    return [];
  }, [routeRes]);
  const [currentRoute, setCurrentRoute] = React.useState<{value: number, label: string} | null>(null);
  const handleChangeRoute = (e : SingleValue<{ value: number, label: string }>) => {
    if (e) setCurrentRoute(e);
  };

  // 2. Clients
  const { data: clientRes, isLoading: clientLoad } = useQuery(
    ['getAllActive', 'clients'],
    () => api.clients.getAllActive(),
  );
  const clientList: {value: number, label: string}[] = React.useMemo(() => {
    const resData = clientRes?.data?.data;
    if (resData) {
      return resData.map((data) => ({
        value: data.id,
        label: data.name,
      }));
    }
    return [];
  }, [clientRes]);
  const [currentClient, setCurrentClient] = React.useState<{value:number, label: string} | null>(null);
  const handleChangeClient = (e : SingleValue<{ value: number, label: string }>) => {
    if (e) setCurrentClient(e);
  };

  // 3. Vending Machine
  // Because each client has vendingMachine, this list are getting from there
  const [currentVM, setCurrentVM] = React.useState<{value: number, label: string} | null>(null);
  const handleChangeVm = (e : SingleValue<{ value: number, label: string }>) => {
    if (e) setCurrentVM(e);
  };
  const [vmList, setVmList] = React.useState<{value:number, label: string}[]>();
  React.useEffect(() => {
    setCurrentVM(null);
    if (clientList && clientList.length && currentClient) {
      const resData = clientRes?.data?.data;
      if (resData) {
        const findVMList = resData.find((client) => client.id === currentClient.value);
        if (findVMList) {
          const clientVM = findVMList.vendingMachines.map((vm) => ({
            value: vm.id,
            label: vm.deviceId,
          }));
          setVmList(clientVM);
        }
      }
    }
  }, [currentClient]);

  return {
    step,
    setStep,
    route: {
      list: routeList,
      load: routeLoad,
      current: currentRoute,
      setCurrent: handleChangeRoute,
    },
    client: {
      list: clientList,
      load: clientLoad,
      current: currentClient,
      setCurrent: handleChangeClient,
    },
    vm: {
      list: vmList,
      current: currentVM,
      setCurrent: handleChangeVm,
    },
  };
}

export default useAnalytics;
